import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { submissionStatisticApi } from "../../../../../../utils";
import { AssessmentTypeEnum, AssessmentTypeTextEnum } from "../../../../../lms-shared/models/AssessmentTypeEnum";
import { ReflectionActionsEnum } from "../../../../../lms-shared/Reflection/Shared/ReflectionActionsEnum";
import { ReflectionComponentsEnum } from "../../../../../lms-shared/Reflection/Shared/ReflectionComponentsEnum";
import { throwApiError } from "../../../../../lms-shared/store/error-handling-actions";
import ScrollLTR from "../../../../../lms-shared/UI/ScrollLTR";
import classes from './ReflectionReportTab.module.css'
import StudentsAnswersPrecents from "../StudentAnswersPrecents/StudentsAnswersPrecents";

const StudentsAnswersPrecentsTypes = {
    FullAnswer: "fullAnswer",
    PartialAnswer: "partialAnswer"
}
const ReflectionReportTab = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const texts = useSelector((state) => state.translate.texts);
    const { homeUrl } = useSelector(state => state.application);
    const [data, setData] = useState([])
    const [answers, setAnswers] = useState([])
    const [notifyText, setNotifyText] = useState()
    const { guid, id } = useParams();

    useEffect(() => {
        if (answers.length === 0 && data.studentsCount === 0)
            setNotifyText(texts.noReflection)
    }, [answers, data])

    function fetchReportsData() {
        if (guid !== "0") {
            const data =
            {
                studyGroupId: id,
                lessonId: guid
            }
            submissionStatisticApi.submissionStatisticsReflectionPost({ submissionReflectionStatisticInput: data }, (error, resdata, response) => {
                if (response.status === 400 && response.text === "\"Toc is not lesson\"") {
                    setNotifyText(texts.tocReflection)
                }
                else if (error) {
                    dispatch(throwApiError({ userMessage: texts.submissionsAllStudentsStatisticError, error: error, statusCode: response?.statusCode, message: "submissionsAllStudentsStatisticPost " + error.message, level: 2, component: "ReflectionReportTab" }))
                }
                else {
                    setNotifyText(null)
                    setAnswers(response.body.assessments || [])
                    setData({
                        studentsCount: response.body.studentsCount,
                        partialAnswerCount: response.body.partialAnswerCount,
                        fullAnswerCount: response.body.fullAnswerCount
                    })
                }
            })
        }
    }


    useEffect(() => {
        fetchReportsData()
    }, [guid]);

    return (
        <ScrollLTR dropStyle={{ height: "calc(100vh - 60px - 78px)" }}>
            {
                notifyText ?
                    <div className={classes.NoReflection}>
                        <div>{notifyText}</div>
                        {/* {notifyText === texts.noReflection && <div className={classes.EditLesson}
                            onClick={() => navigate(`/${homeUrl}/${PathRouter.LESSONS}/${guid}`, { state: { studyGroupId: id } })}>{texts.editLesson}</div>} */}
                    </div>
                    :
                    <div className={classes.ReflectionReport}>
                        <div className={classes.AnswersPercents}>
                            <StudentsAnswersPrecents studentsCount={data.studentsCount} answersCount={data.fullAnswerCount} answerType={StudentsAnswersPrecentsTypes.FullAnswer} />
                            <StudentsAnswersPrecents studentsCount={data.studentsCount} answersCount={data.partialAnswerCount} answerType={StudentsAnswersPrecentsTypes.PartialAnswer} />
                        </div>
                        <div className={classes.ReflectionTypes}>
                            {answers && answers.map((answer, index) => {
                                const QuestionTypeComponent = ReflectionComponentsEnum[Object.keys(AssessmentTypeEnum).find(key => AssessmentTypeTextEnum[key] === answer.assessmentType)];
                                return (
                                    <div key={index}>
                                        <QuestionTypeComponent action={ReflectionActionsEnum.Report} question={answer} />
                                    </div>)

                            })
                            }
                        </div>
                    </div>}
        </ScrollLTR>
    )
}

export default ReflectionReportTab